import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { ICorrespondenceViewModel, ISolicitationViewModel } from 'viewModels';
import Tooltip from '@mui/material/Tooltip';
import { Button as ButtonMUI, Grid, Typography } from '@mui/material';
import * as yup from 'yup';
import { IAddCorrespondenceInputModel, IDeleteCorrespondenceInputModel } from 'inputModels';
import { useForm } from 'react-hook-form';
import { useTheme } from 'styled-components';
import { NavHeader } from '../../components/NavHeader';
import { Body, Container, Content } from './styles';
import { useApp, useAuth } from '../../context';
import { ReactComponent as DeleteIcon } from '../../assets/icons/IconTrashCan.svg';
import { MenuOptionLeftCompany } from '../../components/MenuOptionLeft/Company';
import CorrespondenceController from '../../controller/CorrespondenceController';
import { Button, Input } from '../../components';
import { ModalDeleteCorrespondence } from '../../components/Modals/ModalDeleteCorrespondence';
import { useCorrespondences } from '../../context/correspondences';
import { CorrespondenceType, TypeUser } from '../../types/enums';
import { useAlert } from '../../hooks/useAlert';

export function Correspondence() {
  const app = useApp();
  const { user } = useAuth();
  const alert = useAlert();
  const { correspondences, setCorrespondences, setCorrespondencesSelectedByUser } =
    useCorrespondences();
  const [solicitationsByCorrespondence, setSolicitationsByCorrespondence] = useState<
    ISolicitationViewModel[]
  >([]);
  const [defaultValue] = useState({
    name: '',
  });
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [correspondenceSelected, setCorrespondenceSelected] = useState<ICorrespondenceViewModel>(
    {} as ICorrespondenceViewModel,
  );

  const { colors } = useTheme();

  const correspondenceSchema = yup.object().shape({
    name: yup.string().required('O campo nome é obrigatório'),
  });
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: defaultValue,
    reValidateMode: 'onChange',
    resolver: yupResolver(correspondenceSchema),
  });
  const addCorrespondence = async (data: { name: string }) => {
    app.setLoading(true);
    const input: IAddCorrespondenceInputModel = {
      name: data.name,
      isCollaborator: user.type === TypeUser.COLLABORATOR,
    };
    await CorrespondenceController.addCorrespondence(input)
      .then((response) => {
        const newCorrespondence: ICorrespondenceViewModel = {
          id: response,
          name: data.name,
          type: CorrespondenceType.CUSTOM,
          userId: user.id,
        };
        setCorrespondences((prev) =>
          [...prev, newCorrespondence].sort((a, b) => a.name.localeCompare(b.name)),
        );
        reset();
        alert.show({
          message: 'Serviço de correspondência adicionado com sucesso!',
          type: 'success',
        });
      })
      .catch(() => {
        alert.show({ message: 'Erro ao adicionar serviço de correspondência!', type: 'error' });
      })
      .finally(() => app.setLoading(false));
  };
  const deleteCorrespondence = async (data: IDeleteCorrespondenceInputModel) => {
    app.setLoading(true);
    await CorrespondenceController.deleteCorrespondence(data)
      .then(() => {
        setCorrespondencesSelectedByUser((prev) => prev.filter((el) => el.id !== data.id));
        setCorrespondences((prev) => {
          const newCustomCorrespondences = [...prev];
          return newCustomCorrespondences.filter((el) => el.id !== data.id);
        });
        alert.show({
          message: 'Serviço de correspondência removido com sucesso!',
          type: 'success',
        });
      })
      .catch(() => {
        alert.show({ message: 'Erro ao remover serviço de correspondência!', type: 'error' });
      })
      .finally(() => {
        app.setLoading(false);
      });
  };
  const handleVerifyHasSolicitation = async (correspondence: ICorrespondenceViewModel) => {
    app.setLoading(true);
    CorrespondenceController.correspondencesHasSolicitation(correspondence.id)
      .then((response) => {
        setSolicitationsByCorrespondence(response);
        setIsOpenDeleteModal(true);
      })
      .catch(() => {
        alert.show({
          message: 'Erro ao verificar se o serviço de correspondência possui solicitações!',
          type: 'error',
        });
      })
      .finally(() => app.setLoading(false));
    setCorrespondenceSelected(correspondence);
  };
  return (
    <>
      <NavHeader typeHeader="company" />
      <Body>
        <MenuOptionLeftCompany />
        <Container>
          <div className="header">
            <h1> Adicionar Serviços de Correspondências </h1>
          </div>
          <Content>
            <Input
              name="name"
              placeholder="Nome"
              control={control}
              variant="standard"
              errorText={errors.name?.message}
              lengthInput={100}
            />
            <div className="add">
              <Button
                text="Adicionar"
                dimensions={{ width: '13rem', height: '2.25rem' }}
                onClick={handleSubmit(addCorrespondence)}
              />
            </div>
          </Content>
          <h2>Cadastrados</h2>
          <div className="branchesList">
            {correspondences?.length ? (
              correspondences
                .filter((c) => c.type === CorrespondenceType.CUSTOM)
                .map((c) => (
                  <Tooltip disableInteractive key={c.id} title={c.name} placement="top-start" arrow>
                    <div className="branch" key={c.id}>
                      <div className="headerBranch">
                        <h1>{c.name}</h1>
                        {c.userId && (
                          <div>
                            <ButtonMUI
                              type="button"
                              onClick={() => {
                                handleVerifyHasSolicitation(c);
                              }}
                              className="delete">
                              <DeleteIcon />
                            </ButtonMUI>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tooltip>
                ))
            ) : (
              <Grid container padding="2rem" justifyContent="center">
                <Typography justifyContent="center" align="center" color={colors.primary}>
                  Nenhum serviço encontrado...
                </Typography>
              </Grid>
            )}
          </div>
        </Container>
        <ModalDeleteCorrespondence
          isOpen={isOpenDeleteModal}
          currentCorrespondenceSelected={correspondenceSelected}
          solicitationsByCorrespondence={solicitationsByCorrespondence}
          onRequestClose={() => setIsOpenDeleteModal(false)}
          onRequestRemoveCorrespondence={deleteCorrespondence}
        />
      </Body>
    </>
  );
}
